/**
 *  Model to represent all user tokens
 */
export class UserTokens {
  /**
   * UserTokens constructor
   *
   * @param {string} accessToken JWT token used to access backend
   * @param {string} idToken TBD
   * @param {string} refreshToken Refresh token used to refresh backend token
   *
   */
  constructor(
    public accessToken?: string,
    public idToken?: string,
    public refreshToken?: string
  ) {}
}
